require("./threepl-services-totals-indication.scss");

import {ChangeDetectionStrategy, Component, computed, inject, input} from "@angular/core";
import {bzIconPackageOutline, bzIconSpot, bzIconVolume, bzIconWeight} from "@bringoz/ui/icons";
import {ThreePLServiceDetails} from "../../models/threepl-service-details.model";
import {SplitService} from "../../../../commons/services/split-service.service";

@Component({
  selector: "app-threepl-services-totals-indication",
  templateUrl: "./threepl-services-totals-indication.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicesTotalsIndicationComponent {
  readonly services = input.required<ThreePLServiceDetails[]>();

  private readonly split = inject<SplitService>("splitService" as never);
  readonly weightUnit = this.split.getWeightUnit();
  readonly volumeUnit = this.split.getVolumeUnit();

  readonly icons = {packages: bzIconPackageOutline, spots: bzIconSpot, weight: bzIconWeight, volume: bzIconVolume};

  readonly totals = computed(() => {
    const items = this.services().flatMap((service) => service.items ?? []);
    return {
      packages: items.reduce((sum, i) => sum + (i.count || 0), 0),
      spots: items.reduce((sum, i) => sum + (i.requiredSpots || 0), 0),
      weight: items.reduce((sum, i) => sum + (i.weight || 0), 0),
      volume: items.reduce((sum, i) => sum + (i.volume || i.dimensions?.cube || 0), 0),
    };
  });
}
